import 'leaflet'
import store from '../store'
import {getDepictionByAnnotation} from '../services/repository'

function getName(author) {
  let authorString = ""
  if (author){
    if (author.institutionEnabled){
      authorString = author.institution
    } else {
      if (author.firstname !== null && !author.firstname) {
        authorString = author.lastname
      } else {
        authorString = author.lastname + ", " + author.firstname
      }
    }
    if (author.alias  !==  null && author.alias !== undefined){
      authorString += " " + author.alias
    }
  }
  return authorString
}

function getAuthors(bibliography) {
  var result = "";
  if (bibliography.authorList.length > 3) {
    var author = bibliography.authorList[0];
    result = getName(author) + ", et al.";
  } else {
    for (var ae of bibliography.authorList) {
      if (result === ""){
        result += getName(ae);
      } else {
        result += "/ " + getName(ae)
      }
    }
  }
  return result;
}
function getEditors(bibliography) {
  var result = "";
  if (bibliography.editorList.length > 3) {
    var editor = bibliography.editorList[0];
    result = getName(editor) + ", et al.";
  } else {
    for (var ee of bibliography.editorList) {
      if (result === ""){
        result += getName(ee);
      } else {
        result += "/ " + getName(ee)
      }
    }
  }
  return result;
}
function getTitleORGFull(bibliography) {
  var result = bibliography.subtitleORG === "" ? bibliography.titleORG.trim() : bibliography.titleORG.trim() + ": " + bibliography.subtitleORG.trim();
  return result;
}
function getTitleTRFull(bibliography) {
  var result = bibliography.subtitleTR === "" ? bibliography.titleTR.trim() : bibliography.titleTR.trim() + ": " + bibliography.subtitleTR.trim();
  return result;
}
export function getChronologicalRange(){
  return ["unset", "400BC", "375BC", "350BC", "325BC", "300BC", "275BC", "250BC", "225BC", "200BC", "175BC", "150BC", "125BC", "100BC", "75BC", "50BC", "25BC", "0AD", "25AD", "50AD", "75AD", "100AD", "125AD", "150AD", "175AD", "200AD", "225AD", "250AD", "275AD", "300AD", "325AD", "350AD", "375AD", "400AD", "425AD", "450AD", "475AD", "500AD", "525AD", "550AD", "575AD", "600AD", "625AD", "650AD", "675AD", "700AD", "725AD", "750AD", "775AD", "800AD", "825AD", "850AD", "875AD", "900AD", "925AD", "950AD", "975AD", "1000AD", "1025AD", "1050AD", "1075AD", "1100AD", "1125AD", "1150AD", "1175AD", "1200AD", "1225AD", "1250AD", "1275AD", "1300AD", "1325AD", "1350AD", "1375AD", "1400AD", "1425AD", "1450AD", "1475AD", "1500AD", "1525AD", "1550AD", "1575AD", "1600AD", "1625AD", "1650AD", "1675AD", "1700AD", "1725AD", "1750AD", "1775AD", "1800AD", "1825AD", "1850AD", "1875AD", "1900AD", "1925AD", "1950AD", "1975AD", "2000AD", "unset"]
}
export function getSpliceOfText(text){
  if (text === undefined){
    return "undefined"
  }
  let splice = text.split("</p>")
  if (splice[0]){
    return splice[0] + "</p>"
  } else {
    return text
  }
}
export function getIcosWithChildren(iconography){
  let returnElement = []
  for (var rootElement of store.state.iconography){
    var dummy =  Object.assign({}, rootElement)
    var result = searchTreeForÍco(dummy, iconography)
    if (result != null){
      returnElement.push(result)
    }
  }
  return returnElement
}
export function searchTreeForÍco(element, ids){
  let copy = Object.assign({}, element)
  if (ids.iconographyID === element.iconographyID){
    element["isHeading"] = true
    return element
  } else {
    if (element.children != null) {
      let newChildren = []
      for (var child of element.children) {
        var hasChildren = searchTreeForÍco(child, ids);
        if (hasChildren != null){
          newChildren.push(hasChildren)
          copy.children = newChildren;
          copy["isHeading"] = false
          return copy
        }
      }
    }
  }
  return null
}
export function getIco(element, id){
  if (element.iconographyID === id){
    let ico = JSON.parse(JSON.stringify(element))
    ico.children = []
    return ico
  } else {
    for (let child of element.children){
      let res = getIco(child, id)
      if (res !== null){
        return res
      }
    }
    return null
  }
}
function searchTree(element, ids){
  var newChildren = []
  if (element.children !== null){
    for (var child of element.children) {
      var hasChildren = searchTree(child, ids);
      if (hasChildren !== null){
        newChildren.push(hasChildren)
      }
    }
  }
  let copy = Object.assign({}, element)
  copy.children = newChildren;
  copy['w3cAnno'] = []
  if ((ids.includes(copy.iconographyID)) || (copy.children.length > 0)){
    copy.id = copy.iconographyID
    return copy
  } else {
    return null
  }
}
function searchTreeMinuParents(element, id){
  if ((id === element.iconographyID)){
    let copy = Object.assign({}, element)
    copy.id = copy.iconographyID
    return copy
  } else {
    if (element.children !== null){
      for (var child of element.children) {
        var ico = searchTreeMinuParents(child, id);
        if (ico !== null){
          return ico
        }
      }
    }
  } return null
}

function getTitleENFull(bibliography) {
  var result = "";
  if (bibliography.titleEN === "") {
    result = "";
  } else {
    if (bibliography.officialTitleTranslation) {
      result = "/ " + bibliography.titleEN + (bibliography.subtitleEN === "" ?  "" : "/ " + bibliography.titleEN + ": " + bibliography.subtitleEN + "");
    } else {
      result = bibliography.subtitleEN === "" ? "[" + bibliography.titleEN + "]" : "[" + bibliography.titleEN + ": " + bibliography.subtitleEN + "]";
    }
  }
  return result;
}

export function getWallTree(wallLocationTree, entries, depictionID){
  var newChildren = []
  var result
  var newWallLocationTree = Object.assign({}, wallLocationTree)
  if (wallLocationTree.children){
    if (Array.isArray(newWallLocationTree.children)){
      for (var child of newWallLocationTree.children){
        result = getWallTree(child, entries, depictionID)
        if (result !== null){
          newChildren.push(result)
        }
      }
    } else {
      result = getWallTree(newWallLocationTree.children, entries, depictionID)
      if (result !== null){
        newChildren.push(child)
      }
    }
    newWallLocationTree.children = newChildren
  }
  var match = entries.find(el => el.wallLocationID === newWallLocationTree.wallLocationID)
  if ((match !== undefined) || (newWallLocationTree.children.length > 0)){
    if (match !== undefined){
      if (match.position){
        var positionName = ""
        for (var pe of match.position){
          if (positionName === ""){
            positionName = pe.name
          } else {
            positionName += ", " + pe.name
          }
        }
        if (positionName !== ""){
          newWallLocationTree.name += " (" + positionName + ")"
        }
      }
      if (match.wallDimensions && match.wallDimensions.length > 0){
        let found = false;
        for (var wde of match.wallDimensions){
          if (wde.wallID === newWallLocationTree.wallLocationID && wde.coordinates && wde.coordinates.length > 0 && wde.columns > 1 && wde.registers > 1){
            let coordinatesName = ""
            for (var ce of wde.coordinates){
              if (ce.depictionID === depictionID){
                coordinatesName += (found ? "; " : "") + " reg. " + ce.register + ", no. " + ce.number
                found = true
              }
            }
            if (coordinatesName !== ""){
              newWallLocationTree.name += (found ? "; " : ", ") + coordinatesName
            }
          }
        }
      }

    }
    return newWallLocationTree
  } else {
    return null
  }
}
export function fillPicsContainer(relatedImages, relatedAnnotationList){
  let images = {
    annos: [],
    images: []
  }
  for (var img of relatedImages){
    if (relatedAnnotationList.find(element => parseInt(element.image.split(".")[0]) === img.imageID)) {
      images.annos.push(img)
    } else {
      images.images.push(img)
    }
  }
  return images
}
export function deviceType() {
  const ua = navigator.userAgent;
  if (/(tablet|ipad|playbook|silk)|(android(?!.*mobi))/i.test(ua)) {
    return "tablet";
  } else if (/Mobile|Android|iP(hone|od)|IEMobile|BlackBerry|Kindle|Silk-Accelerated|(hpw|web)OS|Opera M(obi|ini)/.test(ua)) {
    return "mobile";
  }
  return "desktop"
}
export function getIconographyByAnnos(ids){

  var returnElement = []
  for (var rootElement of store.state.iconography){
    var dummy = Object.assign({}, rootElement)
    var result = searchTree(dummy, ids)
    if (result !== null){
      returnElement.push(result)
    }
  }
  return returnElement
}
export function getIconographyByAnnosInGivenTree(ids, iconography){
  var returnElement = []

  for (var rootElement of iconography){
    var dummy = Object.assign({}, rootElement)
    var result = searchTree(dummy, ids)
    if (result !== null){
      returnElement.push(result)
    }
  }
  return returnElement
}

export function getIconographyByID(id){
  var returnElement = {}
  for (var rootElement of store.state.iconography){
    var dummy = Object.assign({}, rootElement)
    var result = searchTreeMinuParents(dummy, id)
    if (result !== null){
      returnElement = result
      break
    }
  }
  return returnElement
}
function addDirection(sortItem, direction){
  if (typeof sortItem === 'object'){
    for (const key in sortItem) {
      sortItem[key]['order'] = direction
    }
    return sortItem
  } else {
    let newSort = {}
    newSort[sortItem] = direction
    return newSort
  }
}
export function prepareSortItem(sort, direction){
  let sortInfo = []
  for (const sortItem of sort){
    if (Array.isArray(sortItem)){

      for (let item of sortItem){
        sortInfo.push(addDirection(item, direction))
      }
    } else {
      sortInfo.push(addDirection(sortItem, direction))
    }
  }

  return sortInfo
}
export function checkImgPermitted(item){
  let isPermit = false
  if (item){
    if (item.filename){
      if (item.accessLevel > 1){
        if (item.isExpiring){
          if (item.expiresAt <= Date.now()){
            return false
          } else {
            return true
          }
        } else {
          return true
        }
      } else {
        isPermit = false
      }
    } else {
      isPermit = false
    }
  } else {
    isPermit = false
  }
  return isPermit
}

export function getWallTreeByIDs(wallIDs, wallLocation, depictionID){
  var wallClone = Object.assign({}, wallLocation)
  var walls = []
  for (var key in wallClone){
    var res = getWallTree(wallClone[key], wallIDs, depictionID)
    if (res !== null){
      walls.push(res)
    }
  }
  return walls
}
export function getWallByID(wallID, wallTrees){
  for (var wallTree of wallTrees){
    if (wallTree.wallLocationID === wallID){
      return wallTree
    }
    var res = getWallByID(wallID, wallTree.children)
    if (res !== null){
      return res
    }
  }
  return null
}

// function getPositionInRegisterSystem(cave, depictionID){
//   if (cave){
//     for (const wall of cave.wallList){
//       for (const wallDimension of wall.wallDimensions){
//         for (const coordinate of wallDimension.coordinates){
//           if (coordinate.depictionID === depictionID){
//             return getWallTreeLabels(getWallTreeByIDs([wall], store.state.wallLocation)[0], "").join(", ") + ", Reg. " + coordinate.register + ", No. " + coordinate.number
//           }
//         }
//       }
//     }
//   }
// }
export function getWallIDsInRegisterSystem(cave, depictionID){
  var wallIDs = []
  if (cave){
    for (const wall of cave.wallList){
      for (const wallDimension of wall.wallDimensions){
        for (const coordinate of wallDimension.coordinates){
          if (coordinate.depictionID === depictionID){
            wallIDs.push(wallDimension.wallID)
          }
        }
      }
    }

  }
  return wallIDs
}
export function isSafari() {
  var ua = navigator.userAgent;
  return ua.includes('Safari') && !ua.includes('Chrome');
}
export function getWallLabels(depiction, label){
  var results = ""
  if (depiction){
    var wallTrees = getWallTreeByIDs(depiction.wallIDs, store.state.wallLocation, depiction.depictionID)
    for (var wallTree of wallTrees){
      var result = getWallTreeLabels(wallTree, label)
      if (results === ""){
        results += result
      } else {
        results += "/ " + result
      }
    }
    if (depiction.positionNotes && depiction.positionNotes !== null){
      if (results !== ""){
        results += ", " + depiction.positionNotes
      } else {
        results += depiction.positionNotes
      }
    }
  }
  return results
}
export function getTagIDsFromRelatedAnnotations(relatedAnnotationList){
  var tagIDs = []
  for (const relatedAnnotation of relatedAnnotationList){
    for (const tag of relatedAnnotation.tags){
      if (tagIDs.indexOf(tag.iconographyID) === -1){
        tagIDs.push(tag.iconographyID)
      }
    }
  }
  return tagIDs
}
export function getWallTreeLabels(wallTree, label){
  var results = []
  if (label === ""){
    label += wallTree.name
  } else {
    label += ", " + wallTree.name
  }
  if (wallTree.children ){
    if (wallTree.children.length > 0){
      for (var child of wallTree.children){
        var res = getWallTreeLabels(child, label)
        results.push(res)
      }
    } else {
      results.push(label)
    }
  } else {
    results.push(label)
  }
  return results
}
export function getAuthorOrEditor(bibliography){
  if (getEditors(bibliography) !== ""){
    return getEditors(bibliography)
  } else if (getAuthors(bibliography) !== ""){
    return getAuthors(bibliography)
  } else {
    return getTitleORGFull(bibliography)
  }
}
export function getWordSplit(inputString) {

  const regex = /[\p{Script=Cyrillic}\p{Script=Han}\p{Script=Latin}\p{Script=Hiragana}\p{Script=Katakana}\p{Script=Hangul}'’0-9*]+|"[^"]+"/gu;

  const matches = inputString.match(regex);

  if (matches) {
    const cleanedWords = matches.map(word => {
      if (word.startsWith('"') && word.endsWith('"')) {
        return "\"" + word.slice(1, -1).toLowerCase() + "\"";
      } else {
        // Entfernt typische Satzzeichen, lässt * aber drin
        return word.replace(/[.,;:'"”“]/g, '').toLowerCase();
      }
    });
    return cleanedWords;
  } else {
    return [];
  }
}
export function getLeipzigKuchastudiesEntries(relatedAnnotatedBibliogrpahy){
  if (relatedAnnotatedBibliogrpahy === undefined){
    return []
  }
  let leipzigKuchaStudiesEntries = []
  for (const bibEntry of relatedAnnotatedBibliogrpahy){
    if (bibEntry.seriesORG && bibEntry.seriesORG.includes('Leipzig Kucha Studies') && bibEntry.url && bibEntry.accessLevel === 2){
      leipzigKuchaStudiesEntries.push(bibEntry)
    }
  }
  return leipzigKuchaStudiesEntries
}
export function bibliographyHasLink(bib){
  if (bib.url){
    return true
  }
  if (bib.uri){
    return true
  }
  return false
}

function cleanResult(str) {
  return str
    // Nur außerhalb von <...> Klammern aufräumen
    .replace(/(>[^<]*)/g, part =>
      part
        .replace(/\s+/g, " ")            // mehrere Spaces → 1
        .replace(/\s+([.,;:!?])/g, "$1") // Leerzeichen vor Satzzeichen weg
        .replace(/([.,;:!?])([^\s])/g, "$1 $2") // fehlendes Space nach Satzzeichen
        .replace(/([.])\s*\./g, "$1")    // doppelte Punkte
        .replace(/\s*\/\s*/g, " / ")     // Slashes normieren
        .replace(/\(\s+/g, "(")
        .replace(/\s+\)/g, ")")
    )
    .trim();
}
function putBibTitleTogether(bibliography, bib, translit, bold, translat, tail) {
  var result = ""
      if (bibliography.hesHan){
        result = cleanResult(
          bib.trim() + "<i>" + translit + "</i>" + bold.trim() + translat + tail.trim()
        );
      } else {
        result = cleanResult(
          bib.trim() + "<i>" + translit.trim() + " " + bold.trim() + "</i>" + translat.trim() + tail.trim()
        );
      }
      result = "<span style='white-space: pre-wrap'>" + result + "</span>";
  return result
}

export function getBibTitle(bibliography){
  if (bibliography.publicationType){
    var bib = "";
    var translit = "";
    var bold = "";
    var translat = "";
    var tail = "";
    if ((bibliography.publicationType.publicationTypeID === 1) || (bibliography.publicationType.publicationTypeID === 3)) {
      if (getAuthors(bibliography) === "") {
        if (getEditors(bibliography) !== "") {
          bib = bib + getEditors(bibliography).trim() + " (ed.)";
        }
      } else {
        bib = bib + getAuthors(bibliography);
      }
      if (bibliography.yearORG !== "") {
        bib = bib.trim() + ", " + bibliography.yearORG + ",";
      } else {
        bib = bib.trim() + ", "
      }
      if (getTitleTRFull(bibliography) !== "") {
        translit = " " + getTitleTRFull(bibliography);
      }
      if (getTitleORGFull(bibliography) !== "") {
        bold = " " + getTitleORGFull(bibliography).trim();
      }
      if (getTitleENFull(bibliography) !== "") {
        translat = getTitleENFull(bibliography);
        if (!translat.startsWith("/")) {
          translat = " " + translat;
        }
      }
      if (bibliography.volumeORG !== "") {
        bold = bold.trim();
        translat = translat.trim();
        tail = tail.trim();
        tail = tail + ", Vol." + bibliography.volumeORG;
      }
      if (bibliography.editionORG !== "") {
        tail = tail + ", Edition: " + bibliography.editionORG;
      }
      if (bibliography.seriesORG !== "") {
        tail = tail + "<span style=\"white-space: nowrap;\">, Series: </span>" + bibliography.seriesORG;
      }
      tail = tail + ". ";
      if (bibliography.publisher !== "") {
        tail = tail + bibliography.publisher;
      }
      if (bibliography.thesisType !== "") {
        if (bibliography.publisher === "") {
          tail = tail + bibliography.thesisType.trim() + " thesis";
        } else {
          tail = tail.trim() + ", " + bibliography.thesisType;
        }
      }
      if (bibliography.quotedPages !== "" && bibliography.quotedPages !== undefined) {
        tail = tail.trim() + ", " + bibliography.quotedPages;
      }
      tail = tail + ". ";
      return putBibTitleTogether(bibliography, bib, translit, bold, translat, tail);
    } else if ((bibliography.publicationType.publicationTypeID === 4) || (bibliography.publicationType.publicationTypeID === 7)) {
      bib = bib + getAuthors(bibliography);
      if (bibliography.yearORG !== "") {
        bib = bib.trim() + ", " + bibliography.yearORG + ",";
      } else {
        bib = bib.trim() + ", "
      }
      if (getTitleTRFull(bibliography) !== "") {
        bib = bib.trim() + " " + getTitleTRFull(bibliography);
      }
      if (getTitleORGFull(bibliography) !== "") {
        bib = bib.trim() + " " + getTitleORGFull(bibliography);
      }
      if (getTitleENFull(bibliography) !== "") {
        translat = getTitleENFull(bibliography);
        if (!translat.startsWith("/")) {
          translat = " " + translat;
        }
        bib = bib + translat;
      }
      bib = bib.trim() + ". In: ";
      if (getEditors(bibliography)  !== "") {
        bib = bib + getEditors(bibliography);
        if (bibliography.editorType === "") {
          bib = bib.trim() + " (" + bibliography.editorType + ")";
        }
      }
      if (bibliography.parentTitleTR !== "") {
        translit = translit.trim() + " " + getTitleTRFull(bibliography);
      }
      if (bibliography.parentTitleORG !== "") {
        bold = bold.trim() + " " + bibliography.parentTitleORG;
      }
      if (bibliography.parentTitleEN !== "") {
        translat = translat.trim() + " [" + bibliography.parentTitleEN + "]";
      }
      tail = tail + ". ";
      if (bibliography.publisher !== "") {
        tail = tail + bibliography.publisher;
      }
      if (bibliography.pagesORG !== "") {
        if (bibliography.publisher === "") {
          tail = tail.trim() + ". " + bibliography.pagesORG;
        } else {
          tail = tail.trim() + ", " + bibliography.pagesORG;
        }
      }
      if (bibliography.url !== "") {
        tail = tail.trim() + ", " + bibliography.url;
        if (bibliography.accessdateORG !== "") {
          tail = tail.trim() + " [" + bibliography.accessdateORG + "]";
        }
      }
      if (bibliography.quotedPages !== "" && bibliography.quotedPages !== undefined) {
        tail = tail.trim() + ", " + bibliography.quotedPages;
      }
      if (tail !== ". "){
        tail = tail.trim() + ". ";
      }
      return putBibTitleTogether(bibliography, bib, translit, bold, translat, tail);
    } else if (bibliography.publicationType.publicationTypeID === 8) {
      bib = bib + getAuthors(bibliography);
      if (bibliography.yearORG !== "") {
        bib = bib.trim() + ", " + bibliography.yearORG + ",";
      } else {
        bib = bib.trim() + ", "
      }
      if (getTitleTRFull(bibliography) !== "") {
        bib = bib.trim() + " " + getTitleTRFull(bibliography);
      }
      if (getTitleORGFull(bibliography) !== "") {
        bib = bib.trim() + " " + getTitleORGFull(bibliography);
      }
      if (getTitleENFull(bibliography) !== "") {
        translat = getTitleENFull(bibliography);
        if (!translat.startsWith("/")) {
          translat = " " + translat;
        }
        bib = bib.trim() + translat;
      }
      if (bibliography.parentTitleORG !== "") {
        bold = bold.trim() + ", " + bibliography.parentTitleORG;
      }
      if (bibliography.volumeORG !== "") {
        bold = bold.replace(/\.\s*$/, "");
        translat = translat.replace(/\.\s*$/, "");
        tail = tail.replace(/\.\s*$/, "");
        tail = tail + ", Vol." + bibliography.volumeORG;
      }
      if (bibliography.issueORG !== "") {
        tail = tail.trim() + " " + bibliography.issueORG;
      }
      if (bibliography.pagesORG !== "" ) {
        if (bibliography.publisher === "") {
          tail = tail.trim() + ". " + bibliography.pagesORG;
        } else {
          tail = tail.trim() + ", " + bibliography.pagesORG;
        }
      }
      if (bibliography.quotedPages !== "" && bibliography.quotedPages !== undefined) {
        tail = tail.trim() + ", " + bibliography.quotedPages;
      }
      tail = tail.trim() + ". ";
      return putBibTitleTogether(bibliography, bib, translit, bold, translat, tail);
    } else if (bibliography.publicationType.publicationTypeID === 5) {
      if (bibliography.parentTitleTR || bibliography.parentTitleEN || bibliography.parentTitleORG){
        bib = bib.trim() + getAuthors(bibliography);
        if (bibliography.yearORG !== "") {
          bib = bib.trim() + ", " + bibliography.yearORG + ",";
        } else {
          bib = bib.trim() + ", "
        }
        if (getTitleTRFull(bibliography) !== "") {
          translit = " " + getTitleTRFull(bibliography) + " ";
        }
        if (getTitleORGFull(bibliography) !== "") {
          if (bibliography.parentTitleORG){
            bold += "<i>"
          } else {
            bold += " "
          }
          bold += getTitleORGFull(bibliography);
          if (bibliography.parentTitleORG){
            bold += "</i>"
          }
        }
        if (getTitleENFull(bibliography) !== "") {
          translat = getTitleENFull(bibliography);
          if (!translat.startsWith("/")) {
            translat = " " + translat;
          }
        }
        if (bibliography.editorType !== undefined){
          translat += " In: "
        }
        const editors = getEditors(bibliography)
        if (editors !== ""){
          translat += editors
        }
        if (bibliography.editorType !== undefined){
          translat += " " + bibliography.editorType + " "
        }
        if (bibliography.parentTitleTR){
          translat += "<i>" + bibliography.parentTitleTR.trim() + "</i>. "
        }
        if (bibliography.parentTitleORG){
          translat += "<i>" + bibliography.parentTitleORG.trim() + "</i>. "
        }
        if (bibliography.parentTitleEN){
          translat += "<i>" + bibliography.parentTitleEN.trim() + "</i>. "
        }
      } else {
        if (getAuthors(bibliography) === "") {
          if (getEditors(bibliography) !== "") {
            bib = bib + getEditors(bibliography) + " (ed.)";
          }
        } else {
          bib = bib + getAuthors(bibliography);
        }
        if (bibliography.yearORG !== "") {
          bib = bib + ", " + bibliography.yearORG + ",";
        } else {
          bib = bib + ", "
        }
        if (getTitleTRFull(bibliography) !== "") {
          translit = " " + getTitleTRFull(bibliography);
        }
        if (getTitleORGFull(bibliography) !== "") {
          bold = " " + getTitleORGFull(bibliography);
        }
        if (getTitleENFull(bibliography) !== "") {
          translat = getTitleENFull(bibliography);
          if (!translat.startsWith("/")) {
            translat = " " + translat;
          }
        }

      }
      if (bibliography.thesisType !== "") {
        if (bibliography.publisher === "") {
          tail = tail + bibliography.thesisType + " thesis";
        } else {
          tail = tail + ", " + bibliography.thesisType;
        }
      }
      if (bibliography.volumeORG !== "") {
        bold = bold.replace(/\.\s*$/, "");
        translat = translat.replace(/\.\s*$/, "");
        tail = tail.replace(/\.\s*$/, "");
        tail = tail + ", Vol." + bibliography.volumeORG;
      }
      if (bibliography.editionORG !== "") {
        tail = tail + ", Edition: " + bibliography.editionORG;
      }
      if (bibliography.numberORG !== "") {
        tail = tail + ", No: " + bibliography.numberORG;
      }
      if (bibliography.publisher !== "") {
        if (tail === ""){
          tail = bibliography.publisher;
        } else {
          tail = tail + ". " + bibliography.publisher;
        }
      }
      if (bibliography.seriesORG !== "") {
        tail = tail + "<span style=\"white-space: nowrap;\">, Series: </span>" + bibliography.seriesORG;
      }
      if (bibliography.volumeORG !== "") {
        bold = bold.replace(/\.\s*$/, "");
        translat = translat.replace(/\.\s*$/, "");
        tail = tail.replace(/\.\s*$/, "");
        tail = tail + ", Vol." + bibliography.volumeORG;
      }
      if (bibliography.issueORG !== "") {
        tail = tail + " / " + bibliography.issueORG;
      }
      if (bibliography.pagesORG !== "") {
        tail = tail + ". " + bibliography.pagesORG;
      }

      if (bibliography.quotedPages !== "" && bibliography.quotedPages !== undefined) {
        tail = tail + ", " + bibliography.quotedPages;
      }
      tail = tail + ". ";
      return putBibTitleTogether(bibliography, bib, translit, bold, translat, tail);

    } else {
      return ("undefined")
    }
  } else {
    return ("undefined")
  }
}

export function getOSDURLs(images){
  let tiles = []
  for (let ie of images) {
    if (ie.caveSketchID){
      tiles.push(process.env.VUE_APP_IIIFAPI + "/iiif/2/kucha%2Fcavesketches%2F" + ie.caveSketchID + "." + ie.imageType + "/info.json")
    } else {
      tiles.push(process.env.VUE_APP_IIIFAPI + "/iiif/2/kucha%2Fimages%2F" + ie.filename + "/info.json")
    }
  }
  return tiles
}
export function filterRelatedAnnotationsByHighlight(hit) {
  const source = hit?._source || {};

  const annotations =
    source.relatedAnnotationList ||
    source.oe?.relatedAnnotationList ||
    [];

  const highlight = hit?.highlight || {};

  if (!annotations.length || !Object.keys(highlight).length) {
    return [];
  }

  const masterImageID =
    source.masterImageID ||
    source.oe?.masterImageID;

  const filteredAnnotations = annotations.filter((anno) => {
    if (!masterImageID) return true;

    const imageField = String(anno.image || '');

    return imageField.includes(String(masterImageID));
  });

  if (!filteredAnnotations.length) return [];

  const stripTags = (html) =>
    String(html).replace(/<[^>]*>/g, '');

  const norm = (s) =>
    String(s)
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .toLowerCase()
      .trim();

  function getValuesAtPath(obj, pathSegments) {
    if (obj == null) return [];

    if (!pathSegments.length) {
      if (
        typeof obj === 'string' ||
        typeof obj === 'number' ||
        typeof obj === 'boolean'
      ) {
        return [String(obj)];
      }

      return [];
    }

    const [head, ...tail] = pathSegments;

    if (Array.isArray(obj)) {
      return obj.flatMap(item =>
        getValuesAtPath(item, pathSegments)
      );
    }

    if (!(head in obj)) return [];

    const next = obj[head];

    if (Array.isArray(next)) {
      return next.flatMap(item =>
        getValuesAtPath(item, tail)
      );
    }

    return getValuesAtPath(next, tail);
  }

  // --------------------------------------------------
  // Highlight-Einträge finden
  // Unterstützt:
  //   relatedAnnotationList.foo
  //   oe.relatedAnnotationList.foo
  //   relatedAnnotationList.foo.keyword
  //   oe.relatedAnnotationList.foo.keyword
  // --------------------------------------------------

  const hlEntries = Object.entries(highlight).filter(([key]) => {
    const normalizedKey = key.replace(/\.keyword$/i, '');

    return (
      normalizedKey === 'relatedAnnotationList' ||
      normalizedKey.startsWith('relatedAnnotationList.') ||
      normalizedKey === 'oe.relatedAnnotationList' ||
      normalizedKey.startsWith('oe.relatedAnnotationList.')
    );
  });

  if (!hlEntries.length) {
    console.log(
      "Keine relevanten Highlight-Einträge gefunden",
      Object.keys(highlight)
    );
    return [];
  }

  // --------------------------------------------------
  // Matcher aus Highlight bauen
  // --------------------------------------------------

  const matchers = hlEntries.map(([rawKey, fragments]) => {
    let key = rawKey.replace(/\.keyword$/i, '');

    // Elasticsearch-Pfad bis zum eigentlichen Annotation-Feld entfernen
    if (key.startsWith('oe.relatedAnnotationList.')) {
      key = key.substring('oe.relatedAnnotationList.'.length);
    } else if (key.startsWith('relatedAnnotationList.')) {
      key = key.substring('relatedAnnotationList.'.length);
    } else if (key === 'oe.relatedAnnotationList') {
      key = '';
    } else if (key === 'relatedAnnotationList') {
      key = '';
    }

    const path = key ? key.split('.') : [];

    const frags = (fragments || [])
      .map(stripTags)
      .map(norm)
      .filter(Boolean);

    return {
      rawKey,
      path,
      frags
    };
  });
  // --------------------------------------------------
  // Annotationen anhand der Highlights filtern
  // --------------------------------------------------

  const annos = filteredAnnotations.filter((anno) => {
    return matchers.some(({ path, frags }) => {
      const values = getValuesAtPath(anno, path).map(norm);

      return frags.some(f =>
        values.some(v => v.includes(f))
      );
    });
  });
  return annos;
}

export function isMobile() {
  if (deviceType() === 'mobile' || deviceType() === 'tablet') {
    return true;
  }
  return false;
}
export function setOSDImgInfo(image){
  if (image.caveSketchID){
    var elm = document.createElement("dl");
    elm.id = "html-overlay"
    var titleHd = document.createElement("dt");
    titleHd.innerHTML = "Filename:"
    titleHd.classList.add("titleHd")
    var title = document.createElement("dd");
    title.innerHTML = image.caveSketchID + "." + image.imageType
    elm.appendChild(titleHd)
    elm.appendChild(title)
  } else {
    var elm = document.createElement("dl");
    elm.id = "html-overlay"
    var titleHd = document.createElement("dt");
    titleHd.innerHTML = "Filename:"
    titleHd.classList.add("titleHd")
    var title = document.createElement("dd");
    title.innerHTML = image.filename
    var copyrightHd = document.createElement("dt");
    copyrightHd.innerHTML = "Copyright:"
    var copyright = document.createElement("dd");
    if (image.copyright === undefined){
      copyright.innerHTML = ""
    } else {
      copyright.innerHTML = image.copyright
    }
    if (image.cc){
      if (image.cc.html != null){
        if (copyright.innerHTML === ""){
          copyright.innerHTML = copyright.innerHTML + image.cc.html
        } else {
          copyright.innerHTML = copyright.innerHTML + "<br>" + image.cc.html
        }
      }
    }
    elm.appendChild(titleHd)
    elm.appendChild(title)
    elm.appendChild(copyrightHd)
    elm.appendChild(copyright)
    if (image.location){
      var locationHd = document.createElement("dt");
      locationHd.innerHTML = "Location:"
      var location = document.createElement("dd");
      location.innerHTML = image.location.county + ', ' + image.location.town + '<br>' + image.location.name
      elm.appendChild(locationHd)
      elm.appendChild(location)
    }
    if (image.inventoryNumber){
      var inventoryNumberHd = document.createElement("dt");
      inventoryNumberHd.innerHTML = "Inventory Number:"
      var inventoryNumber = document.createElement("dd");
      inventoryNumber.innerHTML = image.inventoryNumber
      elm.appendChild(inventoryNumberHd)
      elm.appendChild(inventoryNumber)
    }
    if (image.comment){
      var commentHd = document.createElement("dt");
      commentHd.innerHTML = "Comment:"
      var comment = document.createElement("dd");
      comment.innerHTML = image.comment
      elm.appendChild(commentHd)
      elm.appendChild(comment)
    }
  }

  return elm
}
export function getOSDURL(image){
  let tiles = []
  if (image.caveSketchID){
    tiles.push(process.env.VUE_APP_IIIFAPI + "/iiif/2/kucha%2Fcavesketches%2F" + image.caveSketchID + "." + image.imageType + "/info.json")
  } else {
    tiles.push(process.env.VUE_APP_IIIFAPI + "/iiif/2/kucha%2Fimages%2F" + image.filename + "/info.json")
  }
  return tiles
}
export function getOSDURLCave(image){
  let tiles = []
  tiles.push(process.env.VUE_APP_IIIFAPI + "/iiif/2/kucha%2Fcavesketches%2F"  + image.caveSketchID + "." + image.imageType + "/info.json")
  return tiles
}
export function findAgg(aggs, key){
  for (let agg of aggs){
    if (agg.key === key){
      return agg.doc_count
    }
  }
  return "0"
}
export function buildAgg(aggInfo, reference, aggsObject){
  if (Array.isArray(reference)){
    for (let ref of reference){
      delete aggsObject[ref]
    }
  } else {
    delete aggsObject[reference]
  }

  for (let prop in aggInfo){
    aggsObject[prop] = {}
    if (aggInfo[prop].ids){
      aggsObject[prop]['filter'] = {
      }
      aggsObject[prop].filter[prop] = {
        "filter": {
          "terms" : {
          }
        }
      }
      aggsObject[prop].filter[prop].filter.terms[aggInfo[prop].field] = aggInfo[prop].ids
    }
    aggsObject[prop]['agg'] = {
    }
    aggsObject[prop].agg[prop] = {
      "terms" : {
        "size": 10000
      }
    }
    aggsObject[prop].agg[prop].terms["field"] = aggInfo[prop].field
  }
}
export function getRelatedDepictions(iconographyWithChildren){
  var params = {}
  var allIds = getIdsOfChildren(iconographyWithChildren)
  params.iconographyID = allIds
  var newDepictions = []
  getDepictionByAnnotation(params)
    .then( res => {
      for ( var entry of res.data.hits.hits){
        newDepictions.push(entry._source)
      }
    }).catch(function (error) {
      console.log(error)
    })
  return newDepictions
}
export function getIdsOfChildren(ico, ids){
  var result = []
  if (ico.iconographyID){
    if (ico.children){
      if (ico.children.length > 0){
        for (var child of ico.children){
          result = result.concat(getIdsOfChildren(child, []))
        }
      }
    }
    result.push(ico.iconographyID)

  }
  return result
}
export function getBuckets(element){
  for (let prop in element){
    if (prop === "buckets"){
      return element[prop]
    } else {
      let res = getBuckets(element[prop])
      if (res !== null){
        return res
      }
    }
  }
  return null
}
export function appendFilterToAgg(agg, filter, propertyName){
  for (let prop in filter){
    if (prop === propertyName){
      filter["aggs"] = agg
      return filter
    } else {
      if ( (typeof filter[prop] === "object" || typeof filter[prop] === 'function') && (filter[prop] !== null) ) {
        if (appendFilterToAgg(agg, filter[prop], propertyName) !== null){
          return filter
        }
      }
    }
  }
  return null
}
export function getDepictionLabel(depiction){
  let depictionLabel = ""
  if (depiction.shortName){
    depictionLabel += depiction.shortName
  }
  if (depiction.cave && depiction.cave.caveID !== -1) depictionLabel += ", " + getCaveShortLabel(depiction.cave);
  depictionLabel += ", " + getWallLabels(depiction, "")
  if (deviceType() === "mobile"){
    depictionLabel +=  " (PR-ID " + depiction.depictionID + ")"
  } else {
    depictionLabel +=  " (PR-ID " + depiction.depictionID + ")"
  }
  return depictionLabel
}

export function getDepictionLabelShort(depiction){
  let depictionLabel =  "Painted Representation ID " + depiction.depictionID
  if (depiction.shortName){
    depictionLabel += " (" + depiction.shortName + ")"
  }
  if (depiction.cave && depiction.cave.caveID !== -1) depictionLabel += ", " + getCaveShortLabel(depiction.cave);
  depictionLabel += ", " + getWallLabels(depiction, "")
  return depictionLabel
}
export function getCaveLabel(item){
  if (item.caveID !== -1){
    let site = item.siteID > 0 ? item.site.shortName : "";
    let district = item.districtID > 0 ? item.district.name : "";
    let region = item.regionID > 0 ? item.region.phoneticName + " (" + item.region.originalName + " / "+ item.region.englishName + ")" : "";
    let caveLabel = site + " " + item.officialNumber + (!(district.length === 0) ? " / " + district : "") + (!(region.length === 0) ? " / " + region : "");
    return caveLabel
  } else {
    return "unknown"
  }

}
export function getCaveShortLabel(item){
  if (item.caveID === -1){
    return "unknown"
  }
  return item.site.name + " " + item.officialNumber
}